
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#50646E","d":"M18.953 12.257h7.638v21.508h-7.638z"}}),_c('path',{attrs:{"d":"M22.34 3.531a2.918 2.918 0 00-2.52 1.447L4.031 31.875a2.918 2.918 0 00-.015 2.931 2.929 2.929 0 002.537 1.47h31.574a2.929 2.929 0 002.536-1.47 2.936 2.936 0 00-.014-2.93L24.862 4.977a2.918 2.918 0 00-2.521-1.447zm0 9.356a1.75 1.75 0 011.755 1.754v8.186a1.75 1.75 0 01-1.754 1.754 1.75 1.75 0 01-1.754-1.754V14.64a1.75 1.75 0 011.754-1.754zm-2.338 16.372a2.339 2.339 0 114.678 0 2.339 2.339 0 01-4.678 0z","fill":"#BDCAD0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.727 31.187L26.124 4.162c-1.682-2.914-5.886-2.914-7.568 0L2.953 31.187c-1.682 2.913.42 6.555 3.784 6.555h31.206c3.364 0 5.466-3.642 3.784-6.555zM27.386 3.433c-2.243-3.884-7.85-3.884-10.092 0L1.691 30.46c-2.242 3.884.56 8.74 5.046 8.74h31.206c4.485 0 7.288-4.856 5.046-8.74L27.386 3.433z","fill":"#50646E"}})])
          )
        }
      }
    